import React from 'react';
import Select from 'react-select';

class AdvancedSelect extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            label: '',
            value: this.props.value
        }
    }

    componentWillReceiveProps(props) {
        if (props.defaultValue && this.props.value) {
            console.error('WARNING: it looks like you\'re making a controlled component uncontrolled.  This is generally considered a bad idea.  Please review: https://facebook.github.io/react/docs/forms.html#controlled-components');
        }
        if (props.value) {
            if (this.props.defaultValue) {
                console.error('WARNING: it looks like you\'re making an uncontrolled component controlled.  This is generally considered a bad idea.  Please review: https://facebook.github.io/react/docs/forms.html#controlled-components');
            }
            this.setState({
                value: props.value
            });
        }
    }

    componentWillMount() {
        if (this.props.defaultValue) {
            this.setState({
                value: this.props.defaultValue
            });
        } else if(this.props.value) {
            this.setState({
                value: this.props.value
            });
        }

        if (this.props.form && this.props.name) {
            this.unregister = this.props.form.registerField(this);
        }
    }

    componentWillUnmount(){
        if (this.unregister) {
            this.unregister();
        }
    }

    get value() {
        return this.state.value;
    }

    setValue (val) {
        this.setState({
            value: val
        });
    }

    get valid() {
        return !!this.state.value || !this.props.required;
    }

    get error() {
        if (this.valid) {
            return false;
        }

        let message = this.props.errorMessage || (this.props.required ? 'Please fill out this field' : '');

        message = (typeof message === 'function') ? message(this.value, {
            required: this.props.required
        }) : message;

        return message
    }

    handleChange(val) {
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(val);
        }

        this.setState({
            value: val ? val.value : null,
            label: val ? val.label : ''
        }, () => {
            if (this.props.form) {
                this.props.form.change();
            }
        });
    }

    handleInputChange(label) {
        if (typeof this.props.onInputChange === 'function') {
            this.props.onInputChange(label);
        }

        this.setState({
            label: label
        });
    }

    render () {
        return (
            <span ref="wrapperElm" className="advanced-select-wrapper">
                <Select {...this.props}
                    onInputChange={val => this.handleInputChange(val)}
                    onChange={val => this.handleChange(val)}
                    value={this.state.value}
                    className={['component-advanced-select', this.props.className].join(' ')} />
            </span>
        )
    }
}

export default AdvancedSelect;



// WEBPACK FOOTER //
// ./web-app/components/advanced-select.jsx